import * as AppStrings from 'src/localization/string-ids/app-strings';
import { ContainerType } from 'src/components/common/container-details/ContainerDetailsModel';
import { Thumbnails } from 'src/constants/general-media';

export const getThumbnailFromContainerType = (containerType: ContainerType): string => {
    switch (containerType) {
        case ContainerType.ITEM:
            return Thumbnails.ITEM_THUMBNAIL;
        case ContainerType.TOTE:
            return Thumbnails.TOTE_THUMBNAIL;
        case ContainerType.PALLET:
            return Thumbnails.PALLET_THUMBNAIL;
        case ContainerType.STACKING_AREA:
            return Thumbnails.STACKING_AREA_THUMBNAIL;
        case ContainerType.TRAILER:
            return Thumbnails.TRAILER_THUMBNAIL;
        case ContainerType.DROP_ZONE:
            return Thumbnails.DROPZONE_THUMBNAIL;
        default:
            return '';
    }
}

export const getContainerIdString = (containerType?: ContainerType): string => {
    switch (containerType) {
        case ContainerType.ITEM:
            return AppStrings.CONTAINER_DETAILS_LPN_LABEL;
        case ContainerType.TOTE:
            return AppStrings.CONTAINER_DETAILS_TOTE_ID;
        case ContainerType.PALLET:
            return AppStrings.CONTAINER_DETAILS_PALLET_ID;
        case ContainerType.STACKING_AREA:
            return AppStrings.CONTAINER_DETAILS_STACKING_AREA_ID;
        case ContainerType.DROP_ZONE:
            return AppStrings.CONTAINER_DETAILS_DROP_ZONE_ID;
        case ContainerType.TRAILER:
            return AppStrings.CONTAINER_DETAILS_TRAILER_ID;
        default:
            return AppStrings.CONTAINER_DETAILS_DEFAULT_CONTAINER_ID;
    }
}
